import { type ForwardedRef, forwardRef } from 'react';

import { getSourceEventParams, useAmplitude } from '@crehana/analytics';
import { EmptyTalentNewsWidget } from '@crehana/compass.dashlets';

type TEmptyTalentNewsWidgetProps = {
  organizationSlug: string;
  dataTestId?: string;
};

export const EmptyTalentNewsWidgetComponent = forwardRef<
  HTMLDivElement,
  TEmptyTalentNewsWidgetProps
>(({ organizationSlug, dataTestId }, ref: ForwardedRef<HTMLDivElement>) => {
  const { logEvent } = useAmplitude();

  const onNavigateToBlog = () => {
    logEvent({
      event: 'Talent News Action Clicked',
      data: {
        ...getSourceEventParams(),
        Organization: organizationSlug,
      },
    });
    // Navigate to blog
    window.open('/blog', '_blank', 'noopener,noreferrer');
  };

  return (
    <div ref={ref} data-testid={dataTestId} className="tw-w-full tw-h-full">
      <EmptyTalentNewsWidget onNavigateToBlog={onNavigateToBlog} size="m" />
    </div>
  );
});

EmptyTalentNewsWidgetComponent.displayName = 'EmptyTalentNewsWidgetComponent';
